import { getNoteGenerationEngineConfig } from '../../config';

export function readAutoRetryEnv(): { isOnline: boolean } {
  const { isNavigatorOnline, isConfirmedDesktopOfflineNetworkMode } =
    getNoteGenerationEngineConfig();
  return {
    isOnline: isNavigatorOnline() && !isConfirmedDesktopOfflineNetworkMode(),
  };
}
